












































































































































































import Vue, { PropOptions } from 'vue';
import SearchResult from '@/components/util/SearchResult.vue';
import { strFuzzyMatch } from '@/class/common/util';

export default Vue.extend({
  name: 'SideBarItem',
  components: {
    SearchResult,
  },
  props: {
    isMenu: Boolean,
    enableEditIcon: Boolean,
    upperParentObj: Object,
    upperParentID: Number,
    parentList: Array as PropOptions<any[]>,
    childList: Array as PropOptions<any[]>,
    searchText: String,
    selectedID: String,
    getParentID: Function,
    getParentText: Function,
    getChildID: Function,
    getChildText: Function,
    ownerFlag: Boolean,
  },
  computed: {
    independentList() {
      return this.parentList.filter(v => v.only);
    },
    PARENT_LIST() {
      return this.parentList.filter(v => v.parentID === this.upperParentID);
    },
    ROOT_CHILD_LIST() {
      if (this.upperParentID > 0) {
        return [];
      } else {
        return this.childList.filter(v => this.getParentID(v) === 0);
      }
    },
    SEARCH_RESULT_PARENTS(): number[] {
      // 検索語を含む部署をカンマ区切りで出力
      const resultParents: Set<number> = new Set();
      // 部署名から検索
      for (const prnt of this.PARENT_LIST) {
        if (this.matchOptionText(this.getParentText(prnt))) {
          resultParents.add(this.getParentID(prnt));
          // 親部署も該当に入れる
          if (prnt.parentID) {
            resultParents.add(prnt.parentID);
          }
        }
      }
      // ユーザー名から検索
      for (const chld of this.childList) {
        if (
          !resultParents.has(this.getParentID(chld)) &&
          this.matchOptionText(this.getChildText(chld))
        ) {
          resultParents.add(this.getParentID(chld));
          const targetPrnt = this.PARENT_LIST.find(
            v => this.getParentID(v) === this.getParentID(chld),
          );
          if (targetPrnt) {
            resultParents.add(targetPrnt.parentID);
          }
        }
      }
      const results = [];
      for (const parentID of resultParents.values()) {
        results.push(parentID);
      }
      return results;
    },
  },
  data() {
    return {
      hoverBoardFlag: false,
      hoveredBoardID: '-1',
      isTouchMoved: false,
    };
  },
  methods: {
    onClickParent(v: any) {
      this.$emit('clickParent', v);
      this.$emit('clickItem', v);
    },
    onClickChild(v: any) {
      this.$emit('clickChild', v);
      this.$emit('clickItem', v);
    },
    onClickAccordion(obj: any) {
      this.$set(obj, 'isClosed', !obj.isClosed);
    },
    onClickEdit(v: any) {
      this.$emit('clickEdit', v);
    },
    getChildInParent(parentID: number): any[] {
      return this.childList.filter(v => this.getParentID(v) === parentID);
    },
    getUnderParent(parentID: number): any[] {
      return this.parentList.filter(
        v =>
          this.getParentID(v) !== parentID && v.parentID !== this.upperParentID,
      );
    },
    toggleBoardHoverFlag(flag: boolean, boardID: string) {
      this.hoverBoardFlag = flag;
      this.hoveredBoardID = boardID;
    },
    matchOptionText(text: string): string | null {
      return strFuzzyMatch(this.searchText, text);
    },
    // iOS Safariでclickイベントが発生しないため対策
    // ドラッグしていないtouchendをタップ操作とみなしてclick時の処理を呼び出す
    onTouchMove() {
      this.isTouchMoved = true;
    },
    onTouchEndChild(v: any) {
      if (!this.isTouchMoved) {
        this.onClickChild(v);
        this.isTouchMoved = false;
      }
    },
    onTouchEndParent(vp: any) {
      if (!this.isTouchMoved) {
        this.onClickParent(vp);
        this.isTouchMoved = false;
      }
    },
  },
});
